import React from "react";
import { createRoot } from "react-dom/client";
import { app } from "@microsoft/teams-js";
import App from "./components/App";
import ErrorPage from "./components/ErrorPage";
import "./index.css";

// Check if we're in an iframe (Teams context)
const inIframe = window.self !== window.top;

const existingToken = sessionStorage.getItem("token");
if (existingToken) {
    sessionStorage.removeItem("token");
}

const container = document.getElementById("root");
const root = createRoot(container!);

if (!inIframe) {
    const errorDetails = {
        message: "This app must be opened in Microsoft Teams",
        timestamp: new Date().toISOString(),
        url: window.location.href,
        userAgent: navigator.userAgent,
        context: "Teams Context Check"
    };
    sessionStorage.setItem('errorDetails', JSON.stringify(errorDetails));
    root.render(<ErrorPage />);
} else {
    // Initialiseer Teams SDK met de nieuwe teams.cloud.microsoft origin (niet in standaard SDK lijst)
    // Geen StrictMode: Teams SDK verdraagt geen dubbele initialisatie (StrictMode runt effects 2x in dev)
    app.initialize(['https://teams.cloud.microsoft'])
        .then(() => root.render(<App />))
        .catch(() => root.render(<App />)); // Render App ook bij fout — useTeamsUserCredential handelt het af
}
